import { Navigate } from 'react-router-dom';
import AnalysisPage from './views/Analysis';
import ContentLogsPage from './views/ContentLogs';
import HotRadarsPage from './views/HotRadars';
import RivalAnalysisPage from './views/RivalAnalysis';
import RivalContentLogsPage from './views/RivalContentLogs';

export const traceRoutes = [
  {
    path: 'trace',
    name: '运营中心',
    icon: 'lineChart',
    children: [
      {
        index: true,
        element: <Navigate to="analysis" replace />,
      },
      {
        path: 'analysis',
        name: '运营看板',
        icon: 'barChart',
        element: <AnalysisPage />,
      },
      {
        path: 'rival-analysis',
        name: '竞品看板',
        icon: 'lineChart',
        element: <RivalAnalysisPage />,
      },
      {
        path: 'content-logs',
        name: '自有作品',
        icon: 'fileText',
        element: <ContentLogsPage />,
      },
      {
        path: 'rival-content-logs',
        name: '竞品作品',
        icon: 'fileText',
        element: <RivalContentLogsPage />,
      },
      {
        path: 'hot-radars',
        name: '爆款拆解',
        icon: 'radarChart',
        element: <HotRadarsPage />,
      },
    ],
  },
];
